import React from "react";

import Slider, { sliderClasses, SliderProps } from "@mui/material/Slider";
import styled from "@mui/material/styles/styled";

type StyledSliderProps = SliderProps & { segmented: boolean };

const StyledSlider = styled(({ segmented: _, ...props }: StyledSliderProps) => (
  <Slider {...props} />
))(({ onChange, segmented, theme }) => ({
  borderRadius: "2px",
  height: "6px",
  opacity: 1,
  padding: 0,
  "&:hover": {
    cursor: onChange ? "pointer" : "default",
  },
  "@media (pointer:coarse)": {
    // Mui adds extra padding on this specific condition; override it
    padding: 0,
  },
  [`& .${sliderClasses.thumb}`]: {
    display: "none",
  },
  [`& .${sliderClasses.rail}`]: {
    backgroundColor: segmented
      ? "transparent"
      : theme.palette.shades.neutral[100],
  },
  [`& .${sliderClasses.track}`]: {
    boxShadow: "inset 0px 4.77991px 4.77991px rgba(255, 255, 255, 0.16)",
    height: "6px",
    boxSizing: "border-box",
    borderRadius: 0,
    borderBottomLeftRadius: "2px",
    borderTopLeftRadius: "2px",
    border: "none",
  },
}));

interface ScrubberProps extends Omit<SliderProps, "onChange"> {
  onChange?: (timestamp: number) => void;
  segmented: boolean;
}

const Scrubber = ({ onChange, ...sliderProps }: ScrubberProps) => {
  const handleChange = (event: Event, seconds: number | number[]) => {
    if (Array.isArray(seconds)) {
      // not sure when this would be the case, but handle to appease types
      onChange?.(seconds[0]);
    } else {
      onChange?.(seconds);
    }
  };

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <StyledSlider
      min={0}
      step={1}
      {...sliderProps}
      onChange={handleChange}
      onClick={handleClick}
    />
  );
};

export default Scrubber;
